export function layoutRender() { return `<div class="messaging-box" role="dialog" aria-label="${ this.chatWindowTitle }" style="${  this.__$objToStyleMap(this.style)  }" ld--elist="click,keydown" ld-on-click="onLayoutClick" ld-on-keydown="onKeyDown">
    <messaging-top-bar issurvey="${ this.survey }"></messaging-top-bar>
    ${ !this.survey ? `<transcript-area>
    </transcript-area>`:`` }

    <aria-reader-view>
    </aria-reader-view>
  
    <survey-view issurvey="${ this.survey }">
    </survey-view>

    <footer-area issurvey="${ this.survey }">
    </footer-area>

    ${ this.survey ? `<survey-view>
    </survey-view>`:`` }

</div>`  }